export default "__VITE_ASSET__fc41b3b0__"